import {
  RESET_CHANNEL_STATE,
  SET_CHANNEL_DELIVERY_STATUS,
  SET_CHANNEL_HEADERS,
  SET_CHANNEL_LEDGER,
  SET_CHANNEL_MSG_LOGS,
  SET_CHANNEL_OVERVIEW,
  SET_CHANNEL_REFILL_HISTORY,
  SET_TEMPLATES_SEED,
  SET_WA_CUST_HEAD_BILL,
  SET_WA_CUST_HEAD_DRAFT,
  CLEAR_WA_CUST_HEADER_DRAFT,
  CLEAR_WA_CUST_HEADER_BILL,
} from "../types";

const initialState = {
  ledger: {},
  msgLogs: {},
  overview: {},
  refillHistory: {},
  templatesSeed: [],
  deliveryStatus: {},
  channelSettings: {},
  waCustHeaderBill: {},
  waCustHeaderDraft: {},
};

const channelsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CHANNEL_REFILL_HISTORY:
      return {
        ...state,
        refillHistory: action.payload,
      };
    case SET_CHANNEL_OVERVIEW:
      return {
        ...state,
        overview: action.payload,
      };
    case SET_CHANNEL_DELIVERY_STATUS:
      return {
        ...state,
        deliveryStatus: action.payload,
      };
    case SET_CHANNEL_MSG_LOGS:
      return {
        ...state,
        msgLogs: action.payload,
      };
    case SET_CHANNEL_LEDGER:
      return {
        ...state,
        ledger: action.payload,
      };
    case SET_CHANNEL_HEADERS:
      return {
        ...state,
        channelSettings: action.payload,
      };
    case SET_TEMPLATES_SEED:
      return {
        ...state,
        templatesSeed: action.payload,
      };
    case SET_WA_CUST_HEAD_DRAFT:
      return {
        ...state,
        waCustHeaderDraft: action.payload,
      };
    case SET_WA_CUST_HEAD_BILL:
      return {
        ...state,
        waCustHeaderBill: action.payload,
      };
    case CLEAR_WA_CUST_HEADER_DRAFT:
      return {
        ...state,
        waCustHeaderDraft: {},
      };
    case CLEAR_WA_CUST_HEADER_BILL:
      return {
        ...state,
        waCustHeaderBill: {},
      };
    case RESET_CHANNEL_STATE:
      return initialState;
    default:
      return state;
  }
};

export default channelsReducer;
